var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultGenericCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#9C8665"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5609 5.33331C14.2014 5.33331 13.91 5.62475 13.91 5.98426V8.95794H10.9363C10.5768 8.95794 10.2854 9.24938 10.2854 9.60889V12.4864C10.2854 12.8459 10.5768 13.1373 10.9363 13.1373H13.91V16.1109C13.91 16.4704 14.2014 16.7619 14.5609 16.7619H17.4384C17.7979 16.7619 18.0894 16.4704 18.0894 16.1109V13.1373H21.063C21.4225 13.1373 21.714 12.8459 21.714 12.4864V9.60889C21.714 9.24938 21.4225 8.95794 21.063 8.95794H18.0894V5.98426C18.0894 5.62475 17.7979 5.33331 17.4384 5.33331H14.5609ZM17.5235 26.6666V23.4883C17.5235 23.0842 17.684 22.6965 17.9698 22.4108L21.273 19.1076C21.6839 18.7691 22.2929 18.7919 22.6772 19.1762C23.0858 19.5848 23.0858 20.2474 22.6772 20.656L21.2638 22.0693C20.892 22.4413 20.892 23.0442 21.2638 23.4162C21.6358 23.788 22.2388 23.788 22.6107 23.4162L24.0241 22.0029C25.1765 20.8504 25.1765 18.9818 24.0241 17.8294C23.6849 17.4901 23.2836 17.2508 22.8568 17.1112V15.492C22.8568 14.0894 23.9939 12.9524 25.3965 12.9524C26.0978 12.9524 26.6663 13.5209 26.6663 14.2222V22.3567C26.6663 23.1649 26.3453 23.9401 25.7737 24.5117L23.6187 26.6666H17.5235ZM14.4759 23.4883V26.6666H8.38063L6.22563 24.5117C5.6541 23.9401 5.33301 23.1649 5.33301 22.3567V14.2222C5.33301 13.5209 5.90154 12.9524 6.60285 12.9524C8.00548 12.9524 9.14253 14.0894 9.14253 15.492V17.1112C8.71576 17.2508 8.31451 17.4901 7.97529 17.8294C6.82283 18.9818 6.82282 20.8504 7.97529 22.0029L9.3886 23.4162C9.76053 23.788 10.3635 23.788 10.7355 23.4162C11.1074 23.0442 11.1074 22.4413 10.7355 22.0693L9.32217 20.656C8.91355 20.2474 8.91355 19.5848 9.32217 19.1762C9.70648 18.7919 10.3153 18.7691 10.7264 19.1076L14.0296 22.4108C14.3153 22.6965 14.4759 23.0842 14.4759 23.4883Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultGenericCardIcon);
export default __webpack_public_path__ + "static/media/DefaultGenericCardIcon.3ba0bebeb201e423e743049c8ffff544.svg";
export { ForwardRef as ReactComponent };